// Custom reservation field types. Pure: no React, no Supabase.
//
// A definition is a question a business asks at checkout; an answer is what the
// customer replied. Definitions live on the activity and may be replaced
// wholesale by an offer. Answers carry their own label, copied at booking time,
// so renaming a field never relabels an answer somebody already gave.

export type CustomFieldType = "text" | "number";

interface CustomFieldBase {
  /** Unique within its array; what an answer is filed under. */
  key: string;
  /** Czech, what the customer reads. */
  label: string;
  required: boolean;
}

export interface CustomTextField extends CustomFieldBase {
  type: "text";
  maxLength: number;
}

export interface CustomNumberField extends CustomFieldBase {
  type: "number";
  min: number | null;
  max: number | null;
}

export type CustomFieldDefinition = CustomTextField | CustomNumberField;

export interface CustomFieldAnswer {
  key: string;
  label: string;
  value: string | number;
}

export const customFieldsLimit = 8;
export const customTextFieldDefaultMaxLength = 200;

/** A stored definition list this portal cannot parse. It is neither an override
 *  it can render nor an absence of one, and the difference is load-bearing: read
 *  as an absence it would be shown as inherited and wiped by the next unrelated
 *  save, silently changing what customers are asked. */
export const unreadableCustomFields = "unreadable";
export type UnreadableCustomFields = typeof unreadableCustomFields;

export type StoredCustomFields = CustomFieldDefinition[] | null | UnreadableCustomFields;
